import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useState, useEffect } from 'react';
import Modal from '../../Modal';

const getImageUrl = (image) => (image && image.url ? image.url : image);
const getImageAlt = (image) => (image && (image.caption || image.name)) || '';
const getImageLabel = (image) => {
  if (!image) return '';
  const category = image.category || '';
  const caption = image.caption || '';
  if (category && caption) return `${category}: ${caption}`;
  return category || caption;
};

const ImageGalleryModal = ({ doShow, onClose, images, initialIndex, title }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex || 0);

  useEffect(() => {
    if (doShow) {
      setCurrentIndex(initialIndex || 0);
    }
  }, [doShow, initialIndex]);

  const handleCarouselChange = (index) => {
    setCurrentIndex(index);
  };

  if (!images || !images.length) return <></>;

  const activeLabel = getImageLabel(images[currentIndex]);

  return (
    <Modal
      open={doShow}
      onClose={onClose}
      className="modal-safe-click-zone w-full md:w-3/4 lg:w-2/3 xl:w-1/2 mx-auto overflow-hidden"
    >
      <div className="p-4">
        <div className="text-theme font-bold sm:text-sm xl:text-lg mb-4">{title}</div>
        <div className="relative">
          <Carousel
            key={`gallery-${doShow ? 'open' : 'closed'}-${initialIndex || 0}`}
            selectedItem={currentIndex}
            onChange={handleCarouselChange}
            showThumbs={false}
            showStatus
            showIndicators
            infiniteLoop
            useKeyboardArrows
            autoFocus
            emulateTouch
            dynamicHeight={false}
            swipeable
            className="text-center"
          >
            {images.map((image) => (
              <div
                key={getImageUrl(image)}
                className="relative w-full h-80vh bg-gray-900 overflow-hidden"
              >
                <img
                  src={getImageUrl(image)}
                  alt={getImageAlt(image)}
                  className="absolute top-0 left-0 w-full h-full object-contain"
                />
              </div>
            ))}
          </Carousel>
          {activeLabel && (
            <div className="absolute bottom-0 left-0 right-0 mb-16 text-center pointer-events-none z-10">
              <span className="bg-black bg-opacity-50 text-white text-sm p-1 px-2">
                {activeLabel}
              </span>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

ImageGalleryModal.propTypes = {
  doShow: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        url: PropTypes.string,
        caption: PropTypes.string,
        category: PropTypes.string,
        name: PropTypes.string,
      }),
    ]),
  ),
  initialIndex: PropTypes.number,
  title: PropTypes.string,
};

ImageGalleryModal.defaultProps = {
  doShow: false,
  images: [],
  initialIndex: 0,
  title: 'Photos',
};

export default ImageGalleryModal;
